/**
 * components/CarIcons.jsx — SVG car silhouette icons
 *
 * 4 vehicle category icons: Sedan, Compact, SUV, Van.
 * Simple side-view outlines, stroke-only, no fill.
 * Used in FleetManager vehicle cards and MapSection popups.
 */

export function SedanIcon({ color = 'currentColor', size = 48 }) {
  // Simple sedan/berline silhouette — side view, clean minimal lines
  // Similar to a Dacia Logan profile
  return (
    <svg width={size} height={size} viewBox="0 0 64 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8 24h-4a2 2 0 01-2-2v-4a2 2 0 012-2h2l4-6h12l6-4h14l4 4h6a4 4 0 014 4v6a2 2 0 01-2 2h-4" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <circle cx="14" cy="24" r="4" stroke={color} strokeWidth="1.5"/>
      <circle cx="48" cy="24" r="4" stroke={color} strokeWidth="1.5"/>
      <path d="M18 24h26" stroke={color} strokeWidth="1.5"/>
      <path d="M22 10v6" stroke={color} strokeWidth="1" opacity="0.5"/>
      <path d="M36 6v10" stroke={color} strokeWidth="1" opacity="0.5"/>
    </svg>
  );
}

export function CompactIcon({ color = 'currentColor', size = 48 }) {
  // Small hatchback/citadine — shorter, rounder profile
  return (
    <svg width={size} height={size} viewBox="0 0 56 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8 24h-4a2 2 0 01-2-2v-4a2 2 0 012-2h2l3-5h10l5-5h10l6 6h4a4 4 0 014 4v4a2 2 0 01-2 2h-4" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <circle cx="12" cy="24" r="4" stroke={color} strokeWidth="1.5"/>
      <circle cx="42" cy="24" r="4" stroke={color} strokeWidth="1.5"/>
      <path d="M16 24h22" stroke={color} strokeWidth="1.5"/>
      <path d="M20 11v5" stroke={color} strokeWidth="1" opacity="0.5"/>
    </svg>
  );
}

export function SUVIcon({ color = 'currentColor', size = 48 }) {
  // Taller SUV profile — Dacia Duster style, higher ground clearance
  return (
    <svg width={size} height={size} viewBox="0 0 64 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8 28h-4a2 2 0 01-2-2v-6a2 2 0 012-2h2l3-6h10l4-6h16l6 6h5a4 4 0 014 4v8a2 2 0 01-2 2h-4" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <circle cx="14" cy="28" r="5" stroke={color} strokeWidth="1.5"/>
      <circle cx="50" cy="28" r="5" stroke={color} strokeWidth="1.5"/>
      <path d="M19 28h26" stroke={color} strokeWidth="1.5"/>
      <path d="M23 12v6" stroke={color} strokeWidth="1" opacity="0.5"/>
      <path d="M37 6v12" stroke={color} strokeWidth="1" opacity="0.5"/>
    </svg>
  );
}

export function VanIcon({ color = 'currentColor', size = 48 }) {
  // Utility van — Kangoo style, boxy profile
  return (
    <svg width={size} height={size} viewBox="0 0 64 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8 28h-4a2 2 0 01-2-2v-14a2 2 0 012-2h30l8-4h10a4 4 0 014 4v14a2 2 0 01-2 2h-4" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <circle cx="14" cy="28" r="5" stroke={color} strokeWidth="1.5"/>
      <circle cx="50" cy="28" r="5" stroke={color} strokeWidth="1.5"/>
      <path d="M19 28h26" stroke={color} strokeWidth="1.5"/>
      <path d="M38 10v10" stroke={color} strokeWidth="1" opacity="0.5"/>
      <path d="M20 10v10" stroke={color} strokeWidth="1" opacity="0.5"/>
    </svg>
  );
}

// Helper to get the right icon for a category
export function getCarIcon(category, props = {}) {
  const cat = category ? category.toLowerCase() : 'compact';
  switch (cat) {
    case 'berline': case 'sedan': return <SedanIcon {...props} />;
    case 'suv': case '4x4': return <SUVIcon {...props} />;
    case 'utilitaire': case 'van': case 'utility': return <VanIcon {...props} />;
    case 'citadine': case 'compact': default: return <CompactIcon {...props} />;
  }
}
